(function () {
  var root = document.getElementById('rfc-condition-guide-root');
  if (!root) return;

  var backdrop = root.querySelector('[data-rfc-backdrop]');
  var dialog = root.querySelector('.rfc-modal__dialog');
  var closeBtn = root.querySelector('[data-rfc-close]');
  var lastFocused = null;

  function setOpen(isOpen) {
    if (isOpen) {
      lastFocused = document.activeElement;
      backdrop.setAttribute('aria-hidden', 'false');
      dialog.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      // Focus first focusable in panel
      var focusable = dialog.querySelector('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
      (focusable || dialog).focus();
      trap(true);
    } else {
      backdrop.setAttribute('aria-hidden', 'true');
      dialog.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      trap(false);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      setOpen(false);
    } else if (e.key === 'Tab' && dialog.getAttribute('aria-hidden') === 'false') {
      // basic focus trap
      var focusables = dialog.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
      focusables = Array.prototype.slice.call(focusables);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
  }

  function trap(enable) {
    if (enable) document.addEventListener('keydown', onKeydown);
    else document.removeEventListener('keydown', onKeydown);
  }

  // Delegated open: any element with data-rfc-open="condition-guide"
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-rfc-open="condition-guide"]');
    if (trigger) {
      e.preventDefault();
      setOpen(true);
    }
  });

  // Close handlers
  closeBtn && closeBtn.addEventListener('click', function () { setOpen(false); });
  backdrop && backdrop.addEventListener('click', function () { setOpen(false); });
})();
